import { inject, Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http'
import { map, Observable } from 'rxjs'
import { BrouillonDto } from './dto/brouillon-dto'
import { PageResponse } from './dto/page-dto'
import { toCustomDate } from '../../utils/date.utils'
import { FilterModel, SortModelItem } from 'ag-grid-community'
import { filterOperators } from '../constant/filter-operators.constant'
import { BrouillonIfExistDto } from './dto/brouillon-if-exist-dto'

@Injectable({
    providedIn: 'root',
})
export class BrouillonHttpService {
    private static readonly endpoint = environment.baseUrl + '/brouillon'
    private static readonly filterOperators: Record<string, string> = filterOperators
    private readonly http = inject(HttpClient)

    getBrouillonChantier(
        codeChantier: string,
        pageSize?: number,
        pageNumber?: number,
        sortModel?: SortModelItem[],
        filterModel?: FilterModel,
    ): Observable<PageResponse<BrouillonDto>> {
        let params: HttpParams = new HttpParams()

        if (Number.isInteger(pageSize) && Number.isInteger(pageNumber)) {
            params = params.append('size', pageSize).append('page', pageNumber)
        }
        if (sortModel?.length) {
            params = params.append('sort', `${sortModel[0].colId}:${sortModel[0].sort}`)
        }
        if (filterModel) {
            for (const filter of Object.entries(filterModel)) {
                const [key, value] = filter
                if (value.filterType === 'date') {
                    params = params.append(
                        'search',
                        `${key}:${BrouillonHttpService.filterOperators[value.type]}:${toCustomDate(value.dateFrom)}${value.dateTo ? '|' + toCustomDate(value.dateTo) : ''}`,
                    )
                } else {
                    params = params.append(
                        'search',
                        `${key}:${BrouillonHttpService.filterOperators[value.type]}:${value.filter}`,
                    )
                }
            }
        }
        return this.http.get<PageResponse<BrouillonDto>>(
            BrouillonHttpService.endpoint + `/find/chantier/${codeChantier}`,
            { params },
        )
    }

    getBrouillonCount(codeChantier: string): Observable<number> {
        return this.http
            .get(BrouillonHttpService.endpoint + `/count/chantier/${codeChantier}`, {
                responseType: 'text',
            })
            .pipe(map((counter) => Number(counter)))
    }

    deleteBrouillonById(documentId: number): Observable<void> {
        return this.http.delete<void>(BrouillonHttpService.endpoint + `/delete/${documentId}`)
    }

    getBrouillonById(brouillonId: number): Observable<BrouillonDto> {
        return this.http.get<BrouillonDto>(BrouillonHttpService.endpoint + `/find/${brouillonId}`)
    }

    getBrouillonIfExist(params: BrouillonIfExistDto): Observable<BrouillonDto> {
        return this.http.post<BrouillonDto>(`${BrouillonHttpService.endpoint}/findIfExist`, params)
    }
}
